export function NotFoundPage({ navigate }: { navigate: (path: string) => void }) {
  return (
    <main className="not-found-page">
      <p className="store-kicker">Wild Trails Kids</p>
      <h1>That page is not on this trail.</h1>
      <p>Choose a current destination to continue.</p>
      <button className="store-button" type="button" onClick={() => navigate('/')}>
        Back home
      </button>
    </main>
  );
}
